<template>
  <div class="animated fadeIn">
    <Tables ref="tableGrid"
      :columns="['Período Movimento', 'Documento', 'NumSisBr', 'Conta Corrente', 'Dt. Abertura', 'Valor Saldo Médio', 'Qtde. Dias Limite Crédito', 'Qtde. Dias ADP', 'Situação Conta Corrente' ]"
      :showTipFooter="false"
      v-on:Load="onLoad">
      <tr v-for="obj in this.objList" v-bind:key="obj.id">
        <TableColumn :IsText="true" :status="1" :value="obj.periodoMovimento"/>
        <TableColumn :IsText="true" :status="1" :value="obj.document"/>
        <TableColumn :IsText="true" :status="1" :value="obj.numSisbr"/>
        <TableColumn :IsText="true" :status="1" :value="obj.contaCorrente"/>
        <TableColumn :IsText="true" :status="1" :value="formatDate(obj.dataAberturaContaCorrente)" />
        <TableColumn :IsText="true" :status="1" :value="obj.valorSaldoMedio ? formatValue(obj.valorSaldoMedio) : 'R$ 0,00'" />
        <TableColumn :IsText="true" :status="1" :value="obj.quantidadeDiasLimiteCredito ? obj.quantidadeDiasLimiteCredito.toString() : ''" />
        <TableColumn :IsText="true" :status="1" :value="obj.quantidadeDiasADP ? obj.quantidadeDiasADP.toString() : ''" />
        <TableColumn :IsText="true" :status="1" :value="obj.situacaoContaCorrente" />
      </tr>
    </Tables>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'
import AverageBalanceCCORepository from '@/shared/http/repositories/business/averagebalancecco.js'
import Tools from '@/components/tools/Tools.js'

export default {
  name: 'AverageBalanceCCO',
  mixins: [ActionsForm],
  data () {
    return {
      document: null
    }
  },
  methods: {
    onLoad () {
      if (this.document) {
        this.onLoadAverageBalanceCCO(this.document)
      }
    },
    onLoadAverageBalanceCCO (document) {
      loading.push()
      this.document = document
      AverageBalanceCCORepository.Search(document, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
        .then((response) => {
          this.onResultGrid(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    formatDate (value) {
      let result = ''
      if (value) {
        result = this.moment(value).format('DD/MM/YYYY')
      }
      return result
    },
    formatValue (value) {
      let result
      if (value) {
        result = Tools.formatMoneyBR(value.toString())
      }
      return result
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/associate/tabs/averagebalancecco.vue